import React, {Fragment} from 'react';
import {IconButton,Grid, Table, TableHead,TableBody, TableRow, TableCell} from '@material-ui/core';
import {MoreVert} from '@material-ui/icons';
import _ from 'lodash'
import { withStyles } from "@material-ui/core/styles";
import styled from 'styled-components';
import moment from 'moment';
import numeral from 'numeral';
import shortid from 'shortid';
import { connect } from 'formik';
import { connect as reduxConnect } from "react-redux";
import { compose} from "redux";
import AddButton from 'components/Global/Buttons/AddButton';
import OptionsMenu from "components/Global/OptionsMenu/OptionsMenu";
import SimpleConfirmDialog from 'components/Global/ConfirmationDialogs/SimpleConfirmDialog';
import numberFormatter from 'utils/numberFormatter';
import {
  ChildSectionTitle,
  SideLabelTextWithRefInput,
} from '../FormSectionComponents';
import PersonalGuarantorModalForm from './PersonalGuarantorModalForm';
import {exportPersonalGuarantors} from 'store/state/loan/personalGuarantors';
import {
  PositionedMoreVert,
  StyledTableHead,
  GuarantorTableWrapper,
  AddGuarantorButton,
  HeaderCell,
  OptionsCell,
  RowOptionsCell,
  EmptyGuarantors,
  styles} from './tableElementStyles';


class PersonalGuarantors extends React.Component {  
  state ={
    isModalOpen:false,
    isDeleteDialogOpen: false,    
    guarantorIdToRemove: null,
    currentIndex: 0,
    currentlyAddingId: '',
    isAddingGuarantor:false,
    oldVersion: null,
  }
  options = [
    { id: 0, value: "Edit", onClick: (optionId, row) => { this.editGuarantor(row.id);} },
    { id: 1, value: "Delete", onClick: (optionId, row) => { this.confirmRemove(row.id);} },
  ]
  headerOptions = [
    {id: 1, value: 'Export', onClick: (optionId) => { 
      const loanId = this.props.loanId;            
      this.props.exportPersonalGuarantors({id:  loanId});
      }
    }
  ]
  addGuarantor = () => {
    const {formik} = this.props;
    const personalGuarantors = this._getGuarantors();
    const newPersonalGuarantors = [...personalGuarantors];
    let newid = 'fakenew'+shortid();
    newPersonalGuarantors.push({
      id: newid,
      guarantorName: '',
      netWorth: '',
      liquidity: '',
      leverage: '',
      recoursePercent: '',
      burndown: '',
      notes: '',
      reference: ''
    });
    formik.setFieldValue('personalGuarantors', newPersonalGuarantors);
    this.setState({
      currentlyAddingId: newid,
      currentIndex: newPersonalGuarantors.length -1,
      isModalOpen: true,
      isAddingGuarantor:true            
    })
  }
  editGuarantor = (id) => {
    const personalGuarantors = this._getGuarantors();
    let index = _.findIndex(personalGuarantors, function(o) {
      return o.id == id;
    });
    this.setState({
      oldVersion: {...personalGuarantors[index]},
      currentIndex:index,
      isModalOpen:true,
      isAddingGuarantor:false
    })
  }  
  onClose = () => {
    if(this.state.isAddingGuarantor){
      this.remove(this.state.currentlyAddingId); //new personalGuarantors will have an id set to fakenew+shortid()
    } else {
      this.restoreOldVersion();
    }
    this.setState({
      isModalOpen:false,
      oldVersion: null
    });
  }  
  restoreOldVersion = () => {
    const {oldVersion, currentIndex} = this.state;
    const personalGuarantors = this._getGuarantors();
    personalGuarantors[currentIndex] = oldVersion;
  }
  onEditGuarantor = () => {    
    this.setState({
      isModalOpen:false
    })
  }
  mapGuarantors = (personalGuarantors) => {
    return personalGuarantors.map(x => {      
      let contactId = _.get(x, 'contactId')      
      let netWorth = _.get(x, 'netWorth');
      let liquidity = _.get(x, 'liquidity');
      let leverage = _.get(x, 'leverage');
      let recoursePercent = _.get(x, 'recoursePercent');
      return {
        id: _.get(x, 'id'),        
        contactId: contactId,
        guarantorName:  this._getGuarantorName(contactId) ,
        netWorth: (netWorth || netWorth === 0) ? numberFormatter.maskCurrency(netWorth) : '--',
        liquidity: (liquidity || liquidity === 0) ? numberFormatter.maskCurrency(liquidity) : '--',
        leverage: (leverage || leverage === 0) ? numeral(leverage/100).format('0.00%') : '--',
        recourseAmount: (recoursePercent || recoursePercent === 0) ? numeral(recoursePercent/100).format('0.00%') : '--',
        burndown: this._getBurndown(x),
        notes: _.get(x, 'notes') || '--',
        reference: _.get(x, 'reference') ||'--'
      }
    });   
  }
  
  _getBurndown = (guarantor) => {
    let burndown = _.get(guarantor, 'burndown');
    if(burndown === '1'){
      return 'Yes';
    } else if(burndown === '0'){
      return 'No';
    } else {
      return '--';
    }
  }
  _getGuarantorName = (contactId) => {
    
    if(!contactId)
      return '';
    let found = _.find(this._getContacts(), x => x.value === contactId);    
    if(!found)
      return '--';
    return found.label;
  }
  _getContacts = () => {
    const {formik} = this.props
    const {values} = formik;
    return _.get(values, 'ancillary.contacts',[]);
  }
  _getGuarantors = () => {
    const {formik} = this.props
    const {values} = formik;
    let {personalGuarantors} = values;    
    return personalGuarantors;
  }
  remove = (guarantorId) => {
    const {formik} = this.props;
    const personalGuarantors = this._getGuarantors();
    let newPersonalGuarantors = [...personalGuarantors];
    let index = _.findIndex(newPersonalGuarantors, function(o) {
      return o.id == guarantorId;
    });
    if(index != -1){
      newPersonalGuarantors.splice(index, 1);
    }
    formik.setFieldValue('personalGuarantors', newPersonalGuarantors);
    this.setState({
      isDeleteDialogOpen:false,
    });
  }
  cancelDeletePrepaymentSchedule = () => {
    this.setState({
      isDeleteDialogOpen:false,
      guarantorIdToRemove: null
    });
  }

  openOptionsMenu = (row) => {
    this.setState({
      isOptionsMenuOpen: true
    })
  }
  confirmRemove = (id) => {
    this.setState({
      isDeleteDialogOpen: true,
      guarantorIdToRemove: id
    })
  }
  
  buttonRenderer = (isMenuOpen, clickHandler) => {
    const { classes} = this.props;
    return (
      <IconButton classes={{root: classes.iconButton}}>
        <PositionedMoreVert 
          onClick={clickHandler}/>
      </IconButton>
    )
  }
  createRow = (row) => {
    const {isEditing,classes} = this.props;
    return (
      <TableRow key={row.id}>
        <TableCell style={{minWidth:220}} classes={{root: classes.startCell}}>{row.guarantorName}</TableCell>
        <TableCell >{row.netWorth}</TableCell>
        <TableCell >{row.liquidity}</TableCell>
        <TableCell >{row.leverage}</TableCell>
        <TableCell >{row.recourseAmount}</TableCell>
        <TableCell >{row.burndown}</TableCell>
        <TableCell style={{maxWidth:300}}>{row.notes}</TableCell>      
        {!isEditing && <TableCell colSpan={2}>{row.reference}</TableCell>}
        {isEditing && <TableCell >{row.reference}</TableCell>}        
        {isEditing && <RowOptionsCell>
          <OptionsMenu 
            row={row} 
            buttonRenderer={this.buttonRenderer}
            options={this.options}/>  
          </RowOptionsCell>}        
      </TableRow>
    )
  }

  render(){    
    const {isEditing,formik, classes} = this.props;    
    const {values} = formik;
    const personalGuarantors = _.get(values, 'personalGuarantors',[]);
    const mappedGuarantors = this.mapGuarantors(personalGuarantors);
    const hasGuarantors = mappedGuarantors.length > 0;
    const {isModalOpen,guarantorIdToRemove,isAddingGuarantor,isDeleteDialogOpen, currentIndex} = this.state;    
    return (
      <Fragment>        
        <ChildSectionTitle>Personal Guarantors</ChildSectionTitle>
        <GuarantorTableWrapper container alignItems="flex-start" direction="column">
          {hasGuarantors && <Table padding='none'>
            <StyledTableHead>
              <TableRow classes={{root:classes.headerRow}}>
                <HeaderCell classes={{root: classes.startCell}}>Guarantor</HeaderCell>
                <HeaderCell >Net Worth</HeaderCell>
                <HeaderCell >Liquidity</HeaderCell>
                <HeaderCell >Leverage</HeaderCell>                
                <HeaderCell >Recourse Amount</HeaderCell>
                <HeaderCell >Burndown</HeaderCell>
                <HeaderCell >Notes</HeaderCell>
                <HeaderCell >Reference</HeaderCell>
                <OptionsCell>
                  <OptionsMenu                      
                    buttonRenderer={this.buttonRenderer}                 
                    options={this.headerOptions}/>  
                </OptionsCell>                
              </TableRow>
            </StyledTableHead>
            <TableBody>
              {mappedGuarantors.map(row => this.createRow(row))}
            </TableBody>
          </Table>}
          {!hasGuarantors && <EmptyGuarantors>There are no personal guarantors</EmptyGuarantors>}
          {isEditing && 
          <AddGuarantorButton id="addPersonalGuarantorButton" onClick={this.addGuarantor} title="Add Personal Guarantor"/>}
          <PersonalGuarantorModalForm 
            onCancel={this.onClose}
            onClose={this.onClose}
            index={currentIndex}                 
            onEdit={this.onEditGuarantor}
            isAdding={isAddingGuarantor}
            isOpen={isModalOpen}/>
          </GuarantorTableWrapper>
          <SimpleConfirmDialog
            title="Confirm Delete"
            message="You are about to delete this guarantor from your list. Are you sure you want to do this?"
            modalOpen={isDeleteDialogOpen}
            handleNo={this.cancelDeletePrepaymentSchedule}
            handleYes={() => this.remove(guarantorIdToRemove)}
            noText="No"
            yesText="Yes, Delete"
           />        
      </Fragment>
  )};
}

const mapStateToProps = ({  }) => ({
});

export default compose(
  connect,
  reduxConnect(
    mapStateToProps,
    {      
      exportPersonalGuarantors
    }
  ),
  withStyles(styles),
)(PersonalGuarantors);